import { AppRoutesPaths, IRouteDefinition, RouteAccess } from './types';
import {
  ConfirmSignUp,
  CreatePassword,
  NotFound,
  OAuthToken,
  ResetPassword,
  SignIn,
} from '@sandtech-hub-monorepo/ui-auth-kit';
import { LayoutType } from '@sandtech-hub-monorepo/ui-kit';
import forgotPasswordCover from '../assets/forgot-password-cover.webp';
import loginCover from '../assets/login-cover.webp';
import changePasswordCover from '../assets/change-password-cover.webp';
import Home from '../pages/Home';
import { ProgramPage } from '../pages/Program';
import { ProgramsPage } from '../pages/Programs';
import { SettingsPage } from '../pages/Settings';
import { TranscriptPage } from '../pages/Transcript';
import { Learning, Logo } from '@sandtech-hub-monorepo/ui-kit-site';

export const AppRoutes: Record<
  RouteAccess,
  Record<string, IRouteDefinition>
> = {
  private: {
    home: {
      name: 'home',
      element: <Home />,
      path: AppRoutesPaths.Home,
      layout: LayoutType.Fullscreen,
    },
    program: {
      name: 'program',
      element: <ProgramPage />,
      path: AppRoutesPaths.Program,
      layout: LayoutType.Fullscreen,
    },
    programs: {
      name: 'programs',
      element: <ProgramsPage />,
      path: AppRoutesPaths.Programs,
      layout: LayoutType.Fullscreen,
    },
    learning: {
      name: 'learning',
      element: (
        <Learning
          paymentFAQsLink={AppRoutesPaths.PaymentFAQS}
          programPageLink={AppRoutesPaths.Program}
          learningPageLink={AppRoutesPaths.Learning}
          programsPageLink={AppRoutesPaths.Programs}
          supportPageLink={''} // TODO: Add Support link if we won't use answerbase
        />
      ),
      path: AppRoutesPaths.Learning,
      layout: LayoutType.Fullscreen,
    },
    settings: {
      name: 'settings',
      element: <SettingsPage />,
      path: AppRoutesPaths.Settings,
      layout: LayoutType.Fullscreen,
    },
    transcript: {
      name: 'transcript',
      element: <TranscriptPage />,
      path: AppRoutesPaths.Transcript,
      layout: LayoutType.Fullscreen,
    },
    paymentFAQs: {
      name: 'payment-faqs',
      element: <NotFound homeRoute={AppRoutesPaths.Home} />,
      path: AppRoutesPaths.PaymentFAQS,
      layout: LayoutType.Fullscreen,
    },
  },

  public: {
    login: {
      name: 'login',
      element: (
        <SignIn
          resetPasswordRoute={AppRoutesPaths.ResetPassword}
          homeRoute={AppRoutesPaths.Home}
          signUpRoute={undefined}
          confirmSignUpRoute={AppRoutesPaths.Home}
          updatePasswordRoute={AppRoutesPaths.CreatePassword}
          signInWithEhubLogo={<Logo height={24} />}
          loginCover={loginCover}
        />
      ),
      path: AppRoutesPaths.Login,
      layout: LayoutType.Card,
    },

    confirmSignUp: {
      name: 'confirmSignUp',
      element: (
        <ConfirmSignUp
          loginRoute={AppRoutesPaths.Login}
          confirmSignUpCover={changePasswordCover}
          afterAutoSignIn={AppRoutesPaths.Home}
        />
      ),
      path: AppRoutesPaths.ConfirmSignUp,
      layout: LayoutType.Card,
    },

    changePassword: {
      name: 'changePassword',
      element: (
        <CreatePassword
          resetPasswordRoute={AppRoutesPaths.ResetPassword}
          homeRoute={AppRoutesPaths.Home}
          loginCover={loginCover}
        />
      ),
      path: AppRoutesPaths.CreatePassword,
      layout: LayoutType.Card,
    },

    resetPassword: {
      name: 'resetPassword',
      element: (
        <ResetPassword
          loginRoute={AppRoutesPaths.Login}
          forgotPasswordCover={forgotPasswordCover}
        />
      ),
      path: AppRoutesPaths.ResetPassword,
      layout: LayoutType.Card,
    },

    oauthToken: {
      name: 'oauthToken',
      layout: LayoutType.Blank,
      element: (
        <OAuthToken
          loginRoute={AppRoutesPaths.Login}
          homeRoute={AppRoutesPaths.Home}
        />
      ),
      path: AppRoutesPaths.OauthToken,
    },

    notFound: {
      name: 'notFound',
      path: AppRoutesPaths.NotFound,
      layout: LayoutType.Blank,
      element: <NotFound homeRoute={AppRoutesPaths.Home} />,
    },
  },
};
